// External dependencies
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import React from 'react';

// Internal dependencies
import LanguageSwitch from './LanguageSwitch';
import CmsMenuNav from '@/modules/cms/client/components/CmsMenuNav.component';

export default function NavigationLoggedOut({ currentPath }) {
  const { t } = useTranslation('core');

  return (
    <div className="container">
      <nav
        aria-label={t('Page navigation')}
        className="header-welcome text-center"
        role="navigation"
      >
        {/* Left spacer, which also carries the CMS pages menu. Balances the
            language switch on the right, so the centred content stays
            centred whether or not any pages are flagged. */}
        <span className="flex-side">
          <CmsMenuNav variant="inline" />
        </span>
        <span className="header-welcome-text hidden-xs">
          {t('New to Hostfolk?')}
        </span>
        <a href="/signup" className="btn btn-lg btn-default">
          {t('Join')}
        </a>
        <a href="/signin" className="btn btn-lg btn-inverse">
          {t('Login')}
        </a>
        {currentPath !== '/' && (
          <a
            aria-label={t('Read more about Hostfolk')}
            className="btn btn-link header-more-text hidden-xs"
            href="/"
          >
            {t('Read more')}
          </a>
        )}
        <div className="flex-side language-switch">
          <LanguageSwitch buttonStyle="inverse" />
        </div>
      </nav>
    </div>
  );
}

NavigationLoggedOut.propTypes = {
  currentPath: PropTypes.string.isRequired,
};
